import {StyledProps, React, withStyles, classNames, observer, useEffect, Fragment, useAsync, Popover2} from '@api'
import {Menu, MenuDivider} from '@blueprintjs/core'
import {FlexLayoutToolbarMenu, globalStores, nav, ui} from '@stores'
import {ActiveTabMenuDropdown, FlexLayoutMaximizedToolbarItems, FlexLayoutReportNavigator, FlexLayoutSavingIndicator, FlexLayoutUndoRedoToolbar, NewMaximizedTabToolbarDropdown, RecentReportsHeaderChips} from '@stores/catalog/flexLayout'
import {AppBar, PrimaryIconButton} from 'centric-ui-components'
import {SvgIcon} from '@material-ui/core'
import {ArrowBack} from '@material-ui/icons'
import {ExportViewExcel, WorkspaceChooser, UserMenuDropdownIcon, CatalogSeasonSelectors, CatalogSearchBar, PdfMenuButton, ImageSourceToolbarButton, DevMenuDropdownIcon, useStores, StoresInstanceContext, CurrentWorkspaceSyncToolbarButton, SeasonSelectorNavigation, ContextMenuItem} from '@design-board/components'
import {useMeasure} from 'react-use'
import * as css from './SiteHeader.css'
import {C8MenuButton} from '@modules/c8'

const styles = (theme) => ({
  focused: {
    color: '#FFFFFF',
    borderBottom: '1px solid #FFFFFF'
  },
  underline: {
    color: '#FFFFFF'
  },
  closeIcon: {
    color: '#FFF',
    width: 17,
    height: 17
  },
  backButton: {
    color: '#fff'
  },
  libraryTitleDiv: {
    marginLeft: '18px',
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    textTransform: 'capitalize'
  },
  libraryTitle: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    width: '250px',
    fontSize: 14
  },
  menuItem: {
    fontSize: 14
  },
  arrow: {
    opacity: '0.5'
  }
})

interface MyProps extends StyledProps {
  showSearch?: boolean
  showUser?: boolean
  title?: string | React.ReactElement<any>,
  anchorMenu?: HTMLElement
  showPresentation?: boolean
  showSearchIcon?: boolean
  inputRef?: React.Ref<HTMLElement>
  onClickBack?: (event) => void
  showBackButton?: boolean
  onBackButtonClick?: (e) => void
}

const SiteHeaderComponent = observer<MyProps>(function SiteHeaderComponent({
  classes,
  showPresentation,
  showBackButton,
  title,
  onBackButtonClick
}) {
  const [ref, {width, height}] = useMeasure()

  const stores = useStores() ?? globalStores
  // console.log(stores)
  useEffect(() => {
    stores.site.sizes.siteHeader.height = height
  }, [height])

  const
    {
      flexLayout, flexLayout: {maximizedTab, isMaximized, activeTab, activeOrLastCatalogRoot: catalogRoot},
      ui: {settings}
    } = stores

  if (!flexLayout.layout) return null

  const activeTabStores = activeTab?.vipTabStore?.toolWindowStoresToInject ?? stores,
    {
      catalog, catalog: {catalogConfig, isGlobalStore, settings: {toolbarItems, imageSource}},
      deployments: {deploymentConfig},
      workspaces: {current: workspace, workspaceConfig},
      sidebar, sidebar: {left}
    } = activeTabStores

  return (
    <StoresInstanceContext.Provider value={activeTabStores}>
      <div className={classNames(css.root)}
           data-type='SiteHeader'
           data-sidebar={left.open}
           ref={ref}
      >
        <AppBar position={'fixed'} className={css.titleBar} classes={{toolbar: css.titleToolbar}}>
          <div className={classNames(css.wrapper)}>
            <div className={css.left}>
              {showBackButton && <PrimaryIconButton icon={<ArrowBack className={classes.backButton}/>} disabled={false} onClick={onBackButtonClick}/>}
              {false && deploymentConfig && <FlexLayoutToolbarMenu/>}
              {deploymentConfig && <RecentReportsHeaderChips className={css.reports}/>}
              <ActiveTabMenuDropdown className={css.activeTabMenuDropdown}/>
              {DEBUG && ui.settings.flexLayout.autoUndo && <FlexLayoutUndoRedoToolbar className={css.undoRedo}/>}

              {/*<WorkspaceChooser className={classNames(css.boardSelector, css.buttonWrapper, maximizedTab?.component !== 'catalog' && css.hide)}/>*/}
              {maximizedTab?.component === 'catalog' && <CurrentWorkspaceSyncToolbarButton location='header'/>}

              <SiteHeaderLeftToolbar/>
              {false && /*!flexLayout.activeCatalogRoot &&*/ // We're showing it in the footer right now instead
			   <Fragment>
				   <FlexLayoutReportNavigator/>
				   <FlexLayoutMaximizedToolbarItems className={css.maximizeBar}/>
			   </Fragment>}


              {// Move to 2nd level bar
                false && <div className={css.buttonWrapper}>
                        {(!catalogRoot || !isMaximized || maximizedTab?.component !== 'catalog')
                         ? null
                         : <SeasonSelectorNavigation/>
                        }
				      </div>}
            </div>

            <div className={css.right}>
              {!isGlobalStore && <Fragment>
                {toolbarItems.imageSources && imageSource?.toolbar?.location === 'header' && <div className={css.buttonWrapper}>
		            <ImageSourceToolbarButton className={css.imageSourceDropdown}/>

	            </div>}
              </Fragment>}

              {/*{catalog?.hasLoadedCAs && workspaceConfig.view == 'catalog' && !_.isEmpty(workspaceConfig.catalog.versionQueryIndex) && (<SeasonSelectorFilterDropdown_VersionQueryIndex/>)}*/}
              {// Move to 2nd level bar
                true || maximizedTab?.component !== 'catalog' ? null : workspaceConfig?.seasonSelectors?.length > 0 ? <CatalogSeasonSelectors align='right'/> : null}

              {false && DEBUG && !maximizedTab && <NewMaximizedTabToolbarDropdown/>}
              {false && maximizedTab && <FlexLayoutReportNavigator/>}
              {!catalogRoot?.storesToInject?.catalog?.searcher ? null : workspaceConfig?.view !== 'library' ? activeTabStores.isGlobalStore ? null : <CatalogSearchBar className={classNames(css.searcher, !sidebar.modalSidebar && css.visible)}/> : null}

              <div className={classNames(css.icons)}>
                {workspace && <div className={css.separator}/>}
                <DevMenuDropdownIcon/>
                {/*{showPresentation && <PresentationIcon/>}*/}
                {/*{!isVLPView && showNotes && <NotesOverlay/>}*/}
                {/*{!isVLPView && showActivity && <ActivityOverlay/>}*/}
                {<FlexLayoutMaximizedToolbarItems className={css.maximizeBar}/>}
                {settings?.showC8ButtonInTopBar && <C8MenuButton className={css.c8Link} tooltipPlacement='bottom'/>}
                {/*{(isMaximized) && catalog.isPdfAvailable && <PdfMenuButton/>}*/}
                <UserMenuDropdownIcon/>
              </div>
            </div>
          </div>
        </AppBar>
        {catalogConfig.export && <ExportViewExcel stores={catalog.stores}/>}
      </div>
    </StoresInstanceContext.Provider>
  )
})

export const SiteHeader: any = withStyles(styles as any)(SiteHeaderComponent)

export const PresentationIcon = () => <SvgIcon className={css.presentationIcon} viewBox={'0 0 20 21'}>
  <path
    d={'M0,2 L8,2 C8,0.8954305 8.8954305,2.22044605e-16 10,0 C11.1045695,0 12,0.8954305 12,2 L20,2 L20,4 L19,4 L19,15 L13.25,15 L15,21 L13,21 L11.25,15 L8.75,15 L7,21 L5,21 L6.75,15 L1,15 L1,4 L0,4 L0,2 Z M3,4 L3,13 L17,13 L17,4 L3,4 Z'}/>
</SvgIcon>

export const SiteHeaderLeftToolbar = observer(function SiteHeaderLeftToolbar() {
  const {} = useStores()

  return (<div className={css.leftToolbar}>
    <CatalogFocusButton/>
  </div>)
})

export const CatalogFocusButton = observer(function CatalogFocusButton() {
  const {currentUser: {userSettings: {focusMode}, allFocusChecked, toggleFocusMode, anyFocusModeItemsExplicitlyChecked}} = useStores()


  return (<Popover2
    interactionKind='hover'
    position='bottom-left'
    content={<Menu>
      <ContextMenuItem text='Tabs' icon='application' strikethrough={focusMode.enabled && (focusMode.tabs || allFocusChecked)} onClick={toggleFocusMode('tabs')}/>
      <ContextMenuItem  text='Toolbars' icon='wrench' strikethrough={focusMode.enabled && (focusMode.toolbars || allFocusChecked)} onClick={toggleFocusMode('toolbars')}/>
      <ContextMenuItem text='Footers' icon={'widget-footer'} strikethrough={focusMode.enabled && (focusMode.footers || allFocusChecked)} onClick={toggleFocusMode('footers')}/>
    </Menu>}
  >
    <div>
      <PrimaryIconButton icon='circle' tooltip='Focus Mode'
                         tooltipPosition='right'
                         tooltipStyle='mui'
                         className={css.focusMode}
                         active={focusMode?.enabled}
                         onClick={toggleFocusMode('button')}/>
    </div>
  </Popover2>)
})


// WEBPACK FOOTER //
// ./src/modules/siteHeader/components/SiteHeader.tsx